// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1afb12d","732":"52e982a6"}[chunkId] + ".chunk.js";
};